import { FaGithub, FaLinkedin, FaEnvelope, FaCode, FaFileAlt } from 'react-icons/fa';
import { SiJavascript, SiNodedotjs, SiReact, SiExpress, SiAwsorganizations, SiAwslambda, SiDocker, SiMysql, } from 'react-icons/si';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import { TypingAnimation } from '../components/magicui/typing-animation.tsx';
import { ParticlesDemo } from '../components/basic-components/particles.tsx';

//import {MarqueeDemo} from './components/basic-components/marquee-components.tsx'
//import MediumButton from './components/basic-components/medium-button.jsx';

function Home() {

  return (
    <div className="bg-gray-900 text-white min-h-screen flex flex-col">
      {/* Hero Section */}
      <header className="h-screen flex items-center justify-center relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="images/colorful_bg.jpg"
            alt="Background"
            className="w-full h-full object-cover opacity-100"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 to-gray-900/90" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center z-10"
        >
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="w-48 h-48 md:w-96 md:h-96 mx-auto mb-8 rounded-full overflow-hidden border-4 border-purple-500/30 shadow-lg shadow-purple-500/20 relative"
          >
            <img src="images/image_profile1.jpg" alt="Profile" />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent" />
          </motion.div>
          <h1 className="text-5xl md:text-7xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600">
            Kaartik Gupta
          </h1>
          {/* TypingAnimation*/}
          <TypingAnimation
            className="text-xl md:text-2xl text-gray-300 mb-8"
            duration={50}
            delay={500}
            startOnView={true}
          >
            Senior Software Engineer | Full Stack Developer
          </TypingAnimation>
          <div className="flex gap-4 justify-center">
            <SocialLink href="https://github.com/Kaartikgupta" icon={<FaGithub />} />
            <SocialLink href="https://www.linkedin.com/in/kaartik-gupta/" icon={<FaLinkedin />} />
            <SocialLink href="mailto:kaartik1999@gmail.com" icon={<FaEnvelope />} />
            <SocialLink href="https://leetcode.com/u/kaartik123/" icon={<FaCode />} />
            <SocialLink href="https://drive.google.com/file/d/1UyQl0_h9dXq210dzP5o8qMeW1220YQEU/view?usp=drive_link" icon={<FaFileAlt />} />


          </div>
        </motion.div>
      </header>

      {/* About Section */}
        <Section id="about" title="About Me">
          <div className="max-w-3xl mx-auto text-gray-300">
            <p className="mb-4">
          I am a full stack engineer with a passion for developing backend heavy products using NodeJs.
          I am currently working in Cimpress operating in 25 countries handling customer data and building
          scalable solutions for print on demand e-commerce platforms. 
            </p>
            <p className="mb-12">
          As a Travel and photo enthusiast, I am keen in exploring new places and capturing moments through my lens. I am learning editing and photography skills to enhance my hobby.
          Apart from work, I enjoy reading books on technology and self-improvement, which helps me stay updated with the latest trends and enhance my skills.
            </p>

            <div className="mt-12">
          <h3 className="text-2xl font-semibold mb-6 text-white">Work History ✒️</h3>
          <div className="space-y-8">
            <WorkHistoryItem
              company="Cimpress"
              position="Senior Software Engineer"
              duration="Jun 2023 - Present"
              description={
            <>
              <div>◦ <bold>Customer migration:</bold> Successfully migrated 200,000+ customers from Oracle to an third-party database by designing an end-to-end data migration pipeline using AWS S3, Step Functions, and Lambda, reducing database costs and enabling full ownership of customer data.</div>
              <div>◦ Customer Management Tool: Built a React.js + Redux tool to process CSV-based sales-rep mapping, leveraging AWS Lambda, S3, and SES for validation, processing, and notification workflows.</div>
              <div>◦ Reorder: Led end-to-end development of a reorder feature across frontend and backend, enabling users to repurchase previous orders from the User Account page, generating $5M in revenue over 6 months and delivering a reusable service adopted by multiple business units.</div>
              <div>◦ DNS/R and SMS Preference: Delivered the "Do Not Sell" compliance feature using AWS RDS (PostgreSQL), preventing a $20000 penalty and extending backend services to support SMS consent preferences.</div>
              <div>◦ Preference Architecture: Designed and delivered an end-to-end preference management architecture supporting multiple customer preference types for promotional communications, building a reusable microservice adopted by other teams and backed by AWS RDS (PostgreSQL).</div>
              <div>◦ Wishlist: Led the successful development of the backend to enable users to add items to a wishlist on the "User's Account" page, enhancing user experience, increasing the revenue by 1 Million in last 1 months.</div>
            </>
              }
            />
            <WorkHistoryItem
              company="Cimpress"
              position="Software Engineer"
              duration="Aug 2021 - Jun 2023"
              description={
            <>
              <div>◦ Bundle size improvement: Reduced transactional page bundle size by 66%, improving page load times and increasing overall site performance by 15%.</div>
              <div>◦ Migration of legacy: Developed and migrated legacy code into the React framework, resulting in a bug-free launch across 25 countries and a performance improvement of 40%, greatly increased customer conversion rate, by 17% in transactional pages.</div>
              <div>◦ Authorization: Implemented an authorization layer for backend APIs to strengthen infrastructure security, leveraging the Singleton pattern to ensure minimal performance impact.</div>
              <div>◦ Rebranding: Worked on the complete rebranding of transactional pages to align with the new UI, enhancing the visual appeal and user experience of the site.</div>
            </>
              }
            />
            <WorkHistoryItem
              company="MathanGo"
              position="Wordpress Administrator Intern"
              duration="Jan 2019 - Feb 2019"
              description={
            <>
              <div>◦ Website management: Managed and updated the website using the WordPress platform, incorporating user engaging content like past activities to enhance the site's functionality and user experience.</div>
              <div>◦ SERP Improvement: Boosted the search engine results page (SERP) rankings of the website from ranking of 6th to 2nd, increasing organic traffic and visibility, leading to greater user engagement.</div>
            </>
              }
            />
          </div>
            </div>
            <div className="mt-16">
          <div className="space-y-8">

            <h3 className="text-2xl font-semibold mb-6 text-white">Education 📖</h3>
            <WorkHistoryItem
              company="RNS Institute of Technology"
              position="BE in Computer Science"
              duration="Aug 2017 - Jul 2021">
            </WorkHistoryItem>
          </div>
            </div>
          </div>
        </Section>

        {/* Skills Section */}
<Section id="skills" title="Skills">
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-16">

    <ToolCard
      icon={<SiJavascript className="w-12 h-12" />}
      title="JavaScript"
      description="Modern JavaScript for building scalable frontend and backend applications."
      color="yellow"
      skills={[
        "ES6+",
        "Async/Await",
        "State Management",
        "Browser APIs"
      ]}
    />

    <ToolCard
      icon={<SiNodedotjs className="w-12 h-12" />}
      title="Node.js"
      description="Server-side development with Node.js for scalable and high-performance APIs."
      color="green"
      skills={[
        "Express.js",
        "REST APIs",
        "Authentication",
        "Event Loop"
      ]}
    />

    <ToolCard
      icon={<SiReact className="w-12 h-12" />}
      title="React"
      description="Building interactive and performant user interfaces with React."
      color="cyan"
      skills={[
        "Hooks",
        "Component Architecture",
        "Context API",
        "Performance Optimization"
      ]}
    />

    <ToolCard
      icon={<SiExpress className="w-12 h-12" />}
      title="Express.js"
      description="Lightweight backend framework for building RESTful APIs."
      color="gray"
      skills={[
        "Middleware",
        "Routing",
        "JWT Authentication",
        "Error Handling"
      ]}
    />

    <ToolCard
      icon={<SiAwsorganizations className="w-12 h-12" />}
      title="AWS"
      description="Cloud infrastructure and services for deploying and scaling applications."
      color="orange"
      skills={[
        "IAM",
        "EC2",
        "S3",
        "CloudWatch"
      ]}
    />

    <ToolCard
      icon={<SiAwslambda className="w-12 h-12" />}
      title="AWS Lambda"
      description="Serverless compute for running backend logic without managing servers."
      color="purple"
      skills={[
        "Serverless Architecture",
        "Event-driven Functions",
        "API Gateway",
        "Cold Start Optimization"
      ]}
    />

    <ToolCard
      icon={<SiDocker className="w-12 h-12" />}
      title="Docker"
      description="Containerization for consistent development and deployment environments."
      color="blue"
      skills={[
        "Docker Images",
        "Containers",
        "Docker Compose",
        "CI/CD Integration"
      ]}
    />

    <ToolCard
      icon={<SiMysql className="w-12 h-12" />}
      title="MySQL"
      description="Relational database management for structured and scalable data storage."
      color="teal"
      skills={[
        "Schema Design",
        "Indexes",
        "Joins",
        "Query Optimization"
      ]}
    />

  </div>
</Section>


      {/* Projects Section */}
<Section id="projects" title="Projects & Achievements">

  {/* ===== Featured Projects ===== */}
  <h3 className="text-2xl font-semibold mb-6 text-center">
    Featured Projects
  </h3>

 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 
                max-w-5xl mx-auto mb-20 justify-items-center">
  <ProjectCard
    title="IRA Creations"
    description="A website for an artist to showcase artworks, utilizing HTML/CSS, Node.js, and MongoDB, allowing the artist to create posts, upload content, and manage an admin login."
    tags={["HTML/CSS", "NodeJs", "Express", "MongoDB"]}
    link="#"
    image="images/ira.jpg"
    className="h-48"
  />

  <ProjectCard
    title="Costunes"
    description="A web application for music enthusiasts that integrates YouTube for video streaming, created using ReactJS for an interactive user experience."
    tags={["ReactJS", "Redux", "RTK"]}
    link="#"
    image="images/costunes.png"
    className="h-48"
  />

  <ProjectCard
    title="Portfolio"
    description="A web application which you are currently exploring! Built with ReactJS and TailwindCSS to showcase my skills, projects, and achievements in a visually appealing manner."
    tags={["ReactJS", "TailwindCSS", "Framer Motion"]}
    link="#"
    image="images/image_profile.jpg"
    className="h-48"
  />
</div>


</Section>

      <Section id="contact" title="">

      </Section>

      <ParticlesDemo />

      {/* Navigation */}
      <nav className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-gray-800/80 backdrop-blur-sm px-6 py-3 rounded-full z-50">
        <ul className="flex space-x-8">
          <NavItem to="about" label="About" />
          <NavItem to="skills" label="Skills" />
          <NavItem to="projects" label="Projects" />
          <NavItem to="contact" label="Contact" />
        </ul>
      </nav>

    </div>
  );
}

export default Home;



// Helper Components
const SocialLink = ({ href, icon }) => (
  <motion.a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-2xl text-gray-400 hover:text-white transition-colors"
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
  >
    {icon}
  </motion.a>
);

const Section = ({ id, title, children }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section id={id} className="py-20 px-4">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">{title}</h2>
        {children}
      </motion.div>
    </section>
  );
};


const ProjectCard = ({ title, description, tags, link, image, className }) => (
  <motion.a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{ scale: 1.02 }}
    className="block bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors overflow-hidden"
  >
    <div className="aspect-square relative">
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" />
    </div>
    <div className="p-6">
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-300 mb-4">{description}</p>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag, index) => (
          <span key={index} className="px-3 py-1 bg-gray-700 rounded-full text-sm">
            {tag}
          </span>
        ))}
      </div>
    </div>
  </motion.a>
);

const NavItem = ({ to, label }) => (
  <li>
    <Link
      to={to}
      smooth={true}
      duration={500}
      className="text-gray-400 hover:text-white cursor-pointer transition-colors"
    >
      {label}
    </Link>
  </li>
);

const WorkHistoryItem = ({ company, position, duration, description }) => (
  <motion.div
    initial={{ opacity: 0, x: -20 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.5 }}
    viewport={{ once: true }}
    className="relative pl-8 border-l-2 border-purple-500/30"
  >
    <div className="absolute left-[-9px] top-0 w-4 h-4 rounded-full bg-purple-500/30 border-2 border-purple-500"></div>
    <h4 className="text-xl font-semibold text-white">{company}</h4>
    <div className="flex flex-wrap items-center gap-2 mt-1 mb-2">
      <span className="text-purple-400">{position}</span>
      <span className="text-gray-500">•</span>
      <span className="text-gray-400">{duration}</span>
    </div>
    <p className="text-gray-300">{description}</p>
  </motion.div>
);

const ToolCard = ({ icon, title, description, color, skills }) => (
  <motion.div
    whileHover={{ scale: 1.02 }}
    className="relative group"
  >
    <div className="bg-gray-800 rounded-xl p-6 relative z-10 h-full">
      <div className="flex flex-col items-center text-center">
        <div className={`text-${color}-400 mb-4 transition-colors duration-300 group-hover:text-${color}-300`}>
          {icon}
        </div>
        <h3 className="text-xl font-semibold mb-2 text-white">{title}</h3>
        <p className="text-gray-400 text-sm mb-4">{description}</p>
        <div className="flex flex-wrap gap-2 justify-center">
          {skills.map((skill, index) => (
            <span
              key={index}
              className={`text-xs px-2 py-1 rounded-full bg-gray-700/50 text-gray-300`}
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
    <motion.div
      className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl -z-10"
      style={{
        background: `radial-gradient(circle, ${color}30 0%, transparent 70%)`,
        transform: 'scale(1.1)',
      }}
    />
  </motion.div>
);
